<template>
  <div class="active-prices">
    <div class="wrapp-title">
      <h1>{{$t('price-adj.active-prices.title')}}</h1>
    </div>
    <div class="wrapp-list">
      <div v-for="(prices, key) in pricesAdj" class="lists" :key="key">
        <span class="list-title">{{$t(`price-adj.tab.${key}`)}}</span>
        <ul>
          <li v-for="price in prices" :key="price.price_adjustment_id">
            <generic-price-tile class="price-tile" :identifier="key" :price="price" @remove-price="removePrice" />
          </li>
        </ul>
      </div>
    </div>
    <summary-price class="wrapp-payments"/>
  </div>
</template>

<script>
import GenericPriceTile from 'theme/components/Checkout/PriceAdjustements/ActivePrices/GenericPriceTile'
import SummaryPrice from 'theme/components/Checkout/Cart/SummaryPrice'

export default {
  name: 'ActivePrices',
  computed: {
    pricesAdj () {
      return this.$store.getters['cart/getPricesAdjustments']
    }
  },
  methods: {
    removePrice ($event) {
      return this.$emit('remove-price', $event)
    }
  },
  components: {
    GenericPriceTile,
    SummaryPrice
  }
}
</script>
